import React from 'react';
import { SBB, Directions } from '../Icons/CustomIcons';
import { trackedLinkProps } from '../../services/analytics';

// onTrack: optional, nur für Tracking (s. trackedLinkProps).
export const MapsButton = ({ href, onTrack }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="activity-detail-action-btn activity-detail-action-btn--maps"
    {...trackedLinkProps(onTrack)}
  >
    <Directions size={26} /> Karte
  </a>
);

export const SBBButton = ({ href, onTrack }) => href ? (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="activity-detail-action-btn activity-detail-action-btn--sbb"
    {...trackedLinkProps(onTrack)}
  >
    <SBB size={26} /> SBB
  </a>
) : null;
